import { render } from "./headerpage.vue?vue&type=template&id=1534caa3&scoped=true"
import script from "./headerpage.vue?vue&type=script&lang=js"
export * from "./headerpage.vue?vue&type=script&lang=js"

import "./headerpage.vue?vue&type=style&index=0&id=1534caa3&scoped=true&lang=css"

import exportComponent from "../../../../../../../usr/local/lib/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1534caa3"]])

export default __exports__